/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { createColumnHelper } from '@tanstack/react-table';

import { RowData } from '../../../src/utils';

const PRINT_COLUMN_ID = '__print';

/**
 *
 * Used to create columns that only show up in the print/pdf generation
 *
 * This is syntactic sugar and not needed for this feature to work as the required meta/properties could be manually added
 */
function createPrintColumn<TData extends RowData>() {
  const columnHelper = createColumnHelper<TData>();

  /**
   *
   *
   *  note: When using more than one print column, the id must be unique and provided
   */
  const printColumn: typeof columnHelper.accessor = (accessor, { id, ...rest }) =>
    columnHelper.accessor(accessor, {
      ...rest,
      id: PRINT_COLUMN_ID + id,
      meta: {
        ...rest.meta,
        isRenderable: false,
      },
    });

  // Allow the column id '__select' to be used and still acceptable by the table data
  return printColumn as unknown as typeof columnHelper.accessor;
}

export { createPrintColumn };
